<template>
  <v-container>
    <v-row v-if="supplier">
      <v-col>
        <v-card class="pa-5">
          <v-card-text>
            <v-list dense disabled>
              <v-list-item-group class="d-flex flex-column justify-center">
                <v-list-item class="my-4" style="border: none;">
                  <v-list-item-icon>
                    <v-avatar color="#def6ff" size="30" class="icon-box">
                      <v-icon small color="#00B3FF">mdi-account</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Supplier Name</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{ supplier.name }}</v-col>
                  </v-row>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>

          <v-row class="px-4 pb-4">
            <v-col cols="12" md="4">
              <v-card class="pa-4 text-center" color="#e3f2fd" elevation="2">
                <v-icon large color="primary">mdi-file-document</v-icon>
                <div class="text-h6 font-weight-bold mt-2">{{ currencyCode }}{{ formatNumber(summary.total_po_amount) }}</div>
                <div class="subtitle-2 grey--text text--darken-1">Total PO Amount</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-4 text-center" color="#e8f5e9" elevation="2">
                <v-icon large color="success">mdi-cash-check</v-icon>
                <div class="text-h6 font-weight-bold mt-2">{{ currencyCode }}{{ formatNumber(summary.total_paid) }}</div>
                <div class="subtitle-2 grey--text text--darken-1">Total Paid</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="pa-4 text-center" :color="balanceColor" elevation="2">
                <v-icon large :color="balanceIconColor">mdi-scale-balance</v-icon>
                <div class="text-h6 font-weight-bold mt-2">{{ currencyCode }}{{ formatNumber(summary.balance) }}</div>
                <div class="subtitle-2 grey--text text--darken-1">Outstanding Balance</div>
              </v-card>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-btn @click="fetchData" color="primary" :loading="loading">Refresh Status</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { SupplierService } from "@/services/supplier-service.js";

export default {
  name: "SupplierAccount",
  data() {
    return {
      supplier: null,
      summary: {
        total_po_amount: 0,
        total_paid: 0,
        balance: 0,
      },
      loading: false,
    };
  },
  computed: {
    ...mapSettingsGetters(["currencyCode"]),
    balanceColor() {
      if (this.summary.balance > 0) return "#fff3e0";
      if (this.summary.balance < 0) return "#ffebee";
      return "#e8f5e9";
    },
    balanceIconColor() {
      if (this.summary.balance > 0) return "orange";
      if (this.summary.balance < 0) return "red";
      return "green";
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    fetchData() {
      this.loading = true;
      const uuid = this.$route.params.uuid;
      Promise.all([
        SupplierService.getSupplierInfo(uuid),
        SupplierService.getAccountSummary(uuid),
      ])
        .then(([infoRes, summaryRes]) => {
          this.loading = false;
          if (infoRes.data) this.supplier = infoRes.data;
          if (summaryRes.data.data) this.summary = summaryRes.data.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.detail-label {
  font-weight: bold;
  color: #333;
}
.detail-value {
  font-size: 16px;
}
.icon-box {
  border-radius: 30%;
}
</style>
